import { css } from '@emotion/react'
import { Cell, Flow, FormControl, Grid, Theme, useTheme } from 'bold-ui'
import { CnsField, DateField, TextField } from 'components/form'
import { toDate } from 'util/date/formatDate'

import { MamografiaPerguntaField } from './model-mamografia'

interface MamografiaDadosExameModalStepProps {
  dataNascimentoCidadao: string
  serverTime: Date
}

export function MamografiaDadosExameModalStep(props: Readonly<MamografiaDadosExameModalStepProps>) {
  const { dataNascimentoCidadao, serverTime } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Flow direction='vertical'>
      <Grid>
        <Cell data-testid='dataSolicitacao'>
          <DateField
            name={MamografiaPerguntaField.dataSolicitacao}
            label='Data da solicitação'
            minDate={toDate(dataNascimentoCidadao) ?? undefined}
            maxDate={serverTime}
            required
          />
        </Cell>
        <Cell size={10} data-testid='responsavel'>
          <Flow direction='vertical' justifyItems='stretch' style={styles.container}>
            <FormControl label='Responsável' style={styles.title} required />
            <div data-testid='nomeResponsavel'>
              <TextField name={MamografiaPerguntaField.nomeResponsavel} label='Nome' required />
            </div>
            <div data-testid='cns'>
              <CnsField name={MamografiaPerguntaField.cns} label='CNS' required clearable />
            </div>
          </Flow>
        </Cell>
        <Cell size={10} data-testid='conselho'>
          <Flow direction='vertical' justifyItems='stretch' style={styles.container}>
            <FormControl label='Conselho' style={styles.title} required />
            <div data-testid='siglaNomeConselho'>
              <TextField name={MamografiaPerguntaField.siglaNomeConselho} label='Nome' required clearable />
            </div>
            <div data-testid='numeroConselho'>
              <TextField name={MamografiaPerguntaField.numeroConselho} label='Número' required clearable />
            </div>
          </Flow>
        </Cell>
      </Grid>
    </Flow>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    position: relative;
    margin-top: 1rem;
    padding: 1rem;
    border: 1px solid ${theme.pallete.gray.c80};
  `,
  title: css`
    font-weight: bold;
    position: absolute;
    top: -0.75rem;
    margin-left: -0.75rem;
    padding: 0 0.5rem;
    background-color: ${theme.pallete.surface.main};
  `,
})
